import React, {useRef, useEffect} from 'react';
import {BenefitTag} from '@bonprix/design-system';
import {useAlpiSwatchOuterGap} from '@article-overview/components/hooks/use-alpi-swatch-outer-gap.ts';
import {useTrinity} from '@article-overview/components/hooks/use-trinity.js';

export default function Benefits({benefits, itemId}) {
    const outerGap = useAlpiSwatchOuterGap()
    const ref = useRef()
    const hasTopDeal = benefits.some(benefit => benefit.name?.toLowerCase() === 'top deal');
    const eventSent = useRef(false)
    const {sendTopDealBenefitSeen} = useTrinity()

    useEffect(() => {
        const element = ref.current;
        if (!element || !hasTopDeal) return;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !eventSent.current)  {
                    sendTopDealBenefitSeen(itemId)
                    observer.disconnect();
                    eventSent.current =true
                }
            });
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0
        });

        observer.observe(element);

        return () => observer.disconnect();
    }, [hasTopDeal, itemId]);

    if (benefits.length > 0) {
        return (
            <div className="alpi__article-benefits" style={{paddingLeft: (outerGap/2) + 'px'}} ref={ref}>
                {benefits.map((benefit, index) => {
                        return (<div key={index} className="alpi__article-benefit">
                            <BenefitTag variant={benefit.displayType.toLowerCase()}>{benefit.name}</BenefitTag>
                        </div>);
                    }
                )}
            </div>);
    }
    return <></>;
}